import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export type PositionsDrawerTab = "positions" | "open-orders" | "rfq";

export const positionsDrawerTabAtom = atomWithStorage<PositionsDrawerTab>(
  "positionsDrawerTab",
  "positions",
);

export const usePositionsDrawerTab = () => {
  const [positionsDrawerTab, setPositionsDrawerTab] = useAtom(
    positionsDrawerTabAtom,
  );

  return {
    positionsDrawerTab,
    setPositionsDrawerTab,
  };
};
